let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1WNp5")).then(() => parcelRequire('hfuHa'));